import {
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"


export type CardWithNoFooterProps = {
  children: React.ReactNode,
  cardTitle: string,
  cardDescription: string
}
export function CardWithNoFooter({
  children,
  cardTitle,
  cardDescription}:CardWithNoFooterProps) {


  return (
    <div className="w-[400px]">
      <CardHeader>
        <CardTitle className="text-2xl text-center font-serif text-primary200">{cardTitle}</CardTitle> 
        <CardDescription className="text-center font-medium text-primary200">{cardDescription}</CardDescription>
      </CardHeader>
      <CardContent className="px-12">
        {children}
      </CardContent>
    </div>
  )
}